import { z } from "zod";

export const OnboardingChecklistStepSchema = z.enum([
  "deposit",
  "portfolio",
  "investment",
]);
export type OnboardingChecklistStep = z.infer<
  typeof OnboardingChecklistStepSchema
>;

export const OnboardingChecklistSchema = z.object({
  version: z.literal(1),
  exempt: z.boolean(),
  deposit: z.boolean(),
  portfolio: z.boolean(),
  investment: z.boolean(),
});
export type OnboardingChecklist = z.infer<typeof OnboardingChecklistSchema>;

export const NEW_USER_CHECKLIST: OnboardingChecklist = {
  version: 1,
  exempt: false,
  deposit: false,
  portfolio: false,
  investment: false,
};

export function isOnboardingChecklistComplete(
  progress: OnboardingChecklist,
): boolean {
  return (
    progress.exempt ||
    (progress.deposit && progress.portfolio && progress.investment)
  );
}

/** Completion is monotonic, including responses from overlapping requests. */
export function mergeOnboardingChecklist(
  previous: OnboardingChecklist | null | undefined,
  next: OnboardingChecklist,
): OnboardingChecklist {
  return {
    version: 1,
    exempt: Boolean(previous?.exempt || next.exempt),
    deposit: Boolean(previous?.deposit || next.deposit),
    portfolio: Boolean(previous?.portfolio || next.portfolio),
    investment: Boolean(previous?.investment || next.investment),
  };
}
